<!-- Domain-move announcement: shown on the full-page workforce login/signup only,
     never in the login dialog -->
<app-wf-domain-move-banner *ngIf="!isDialog && isWorkforceLogin"></app-wf-domain-move-banner>

<div class="tw-flex" [ngClass]="{'tw-min-h-full': !isDialog, 'dialog-mode': isDialog}">
  <div
    id="login-signup"
    class="tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-bg-gray-100 dark:tw-bg-gray-900 tw-min-w-[50%]">
    <!-- Close button for dialog mode -->
    <button
      *ngIf="isDialog"
      mat-icon-button
      (click)="closeDialog()"
      class="tw-absolute tw-top-1 tw-right-1 tw-z-10 tw-text-black-white-dynamic">
      <mat-icon>close</mat-icon>
    </button>

    <!-- dark mode switch -->
    <app-dark-mode-toggle
      customClasses="tw-mt-2 tw-ml-2 lg:tw-mt-4 lg:tw-ml-4"
      [ngClass]="{'tw-hidden': isWorkforceLogin}"></app-dark-mode-toggle>

    <!-- Main Content -->
    <main
      class="login-signup-main tw-flex-grow tw-flex tw-flex-col tw-items-center tw-justify-center dark:tw-bg-gray-900 tw-p-0 xs:tw-px-2">
      <!-- invite message -->
      <app-alert
        *ngIf="isInvite && inviteType == 'personal'"
        alertType="info"
        class="tw-my-6 tw-max-w-full">
        <div id="invite" class="tw-flex tw-flex-col">
          <p class="tw-my-1 tw-flex tw-flex-col tw-text-sm md:tw-text-base">
            <span class="tw-flex tw-flex-wrap tw-gap-1">
              You were invited to Live Data by
              <span class="dark:tw-text-white tw-break-all">
                {{invitation.invitedBy}}
              </span>
            </span>
            <span class="tw-break-all"> ({{invitation.invitedByEmail}}). </span>
          </p>
          <p class="tw-mb-1">Create an account to get started.</p>
        </div>
      </app-alert>

      <!-- sign up -->
      <section
        *ngIf="!isActionLogin && !inviteError"
        class="dark:tw-bg-gray-900 tw-flex tw-flex-col tw-items-center tw-justify-center tw-mx-auto tw-min-w-[90%] lg:tw-py-0 lg:tw-min-w-[500px] tw-w-full">
        <!-- Feature Locked display -->
        <div *ngIf="isDialog && isPalMode" class="tw-mb-4 tw-px-4 tw-mt-6 tw-max-w-[500px]">
          <div class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="tw-text-teal-400">lock</mat-icon>
            <h2 class="tw-text-xl tw-font-bold tw-my-0 tw-text-white">FEATURE LOCKED</h2>
          </div>
          <p class="tw-text-lg tw-text-gray-300 tw-mt-2">
            Full workforce.ai feature access requires a login, but signup is FREE!
          </p>
        </div>
        <a
          *ngIf="!isDialog && !isPalMode"
          routerLink="/"
          class="tw-mb-6 lg:tw-mb-8 tw-w-36 sm:tw-w-48">
          <img
            *ngIf="!isWorkforceLogin"
            class="ldt-logo"
            src="../../assets/img/logo-white.svg"
            alt="logo" />
          <img
            *ngIf="isWorkforceLogin"
            class="ldt-logo"
            src="../../assets/img/workforce_logo_white.svg"
            alt="logo" />
        </a>
        <div
          class="tw-w-full tw-bg-white tw-rounded-md tw-shadow md:tw-mt-0 sm:tw-max-w-md dark:tw-bg-gray-800 xl:tw-p-0">
          <div class="tw-p-6 tw-space-y-4 md:tw-space-y-6 sm:tw-p-8">
            <h1
              class="tw-text-xl tw-font-semibold tw-my-0 tw-text-gray-800 md:tw-text-2xl dark:tw-text-gray-100 tw-tracking-tight">
              {{(inviteToken || cachedGoogleUser || cachedMicrosoftUser) ? 'Finish creating your account' : 'Create your account'}}
            </h1>

            <!-- If they already signed in with social provider but just don't have an account yet, hide the social signin buttons -->
            <ng-container *ngIf="!cachedGoogleUser && !cachedMicrosoftUser">
              <!-- Google Sign In Button - Moved to top -->
              <div class="tw-mt-4 tw-mb-6">
                <asl-google-signin-button
                  type="standard"
                  size="large"
                  text="signup_with"
                  [theme]="'filled_white'"></asl-google-signin-button>
              </div>

              <!-- Microsoft Sign In Button -->
              <div class="tw-mb-6">
                <button
                  type="button"
                  (click)="signInWithMicrosoft()"
                  class="tw-w-full tw-flex tw-items-center tw-px-3 tw-py-[9px] tw-text-sm tw-font-normal tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-primary_purple-500 tw-transition-all">
                  <svg
                    class="tw-w-5 tw-h-5 tw-mr-3"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1h10v10H1z" fill="#f25022" />
                    <path d="M12 1h10v10H12z" fill="#00a4ef" />
                    <path d="M1 12h10v10H1z" fill="#ffb900" />
                    <path d="M12 12h10v10H12z" fill="#7fba00" />
                  </svg>
                  <span class="tw-flex-1 tw-text-center">Sign up with Microsoft</span>
                </button>
              </div>

              <!-- OR Divider -->
              <div class="tw-relative tw-py-2">
                <div class="tw-absolute tw-inset-0 tw-flex tw-items-center">
                  <div
                    class="tw-w-full tw-border-t tw-border-gray-300 dark:tw-border-gray-600"></div>
                </div>
                <div class="tw-relative tw-flex tw-justify-center">
                  <span
                    class="tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
                    OR
                  </span>
                </div>
              </div>
            </ng-container>

            <!-- They signed in with Google, but don't have an account and don't have an invitation -->
            <ng-container *ngIf="cachedGoogleUser && !inviteToken">
              <p class="tw-text-dark-light-dynamic tw-mb-6 tw-tracking-wide tw-text-base">
                You don't have an account yet. Would you like to create one with
                <span
                  class="tw-font-medium tw-text-gray-800 dark:tw-text-white tw-inline-block tw-px-2.5 tw-py-0.5 tw-rounded-md tw-bg-gray-200 tw-bg-opacity-80 dark:tw-bg-gray-700">
                  {{cachedGoogleUser?.email}}
                </span>
                ?
              </p>

              <form
                [formGroup]="createAccountGoogleForm"
                (ngSubmit)="createAccountWithGoogle()"
                class="tw-space-y-4 md:tw-space-y-6">
                <label
                  for="companyName"
                  class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                  Account Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  formControlName="companyName"
                  placeholder="Your new account name"
                  required
                  class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />

                <div
                  class="tw-flex tw-items-center tw-justify-center tw-mb-8 tw-text-black-white-dynamic">
                  <mat-checkbox formControlName="termsAgreed" class="tw-text-sm">
                    I agree to the
                    <a
                      href="https://www.livedatatechnologies.com/legals"
                      target="_blank"
                      class="hover:tw-underline">
                      Terms and Privacy Policy
                    </a>
                  </mat-checkbox>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-stroked-button
                    (click)="cancelCreateAccount()"
                    class="tw-text-sm tw-leading-9">
                    Cancel
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [class.spinner]="loading"
                    [disabled]="createAccountGoogleForm.invalid || loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9">
                    Create Account
                  </button>
                </div>
              </form>
            </ng-container>

            <!-- They signed in with Microsoft, but don't have an account and don't have an invitation -->
            <ng-container *ngIf="cachedMicrosoftUser && !inviteToken">
              <p class="tw-text-dark-light-dynamic tw-mb-6 tw-tracking-wide tw-text-base">
                You don't have an account yet. Would you like to create one with
                <span
                  class="tw-font-medium tw-text-gray-800 dark:tw-text-white tw-inline-block tw-px-2.5 tw-py-0.5 tw-rounded-md tw-bg-gray-200 tw-bg-opacity-80 dark:tw-bg-gray-700">
                  {{cachedMicrosoftUser?.email}}
                </span>
                ?
              </p>

              <form
                [formGroup]="createAccountGoogleForm"
                (ngSubmit)="createAccountWithMicrosoft()"
                class="tw-space-y-4 md:tw-space-y-6">
                <label
                  for="companyName"
                  class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                  Account Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  formControlName="companyName"
                  placeholder="Your new account name"
                  required
                  class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />

                <div
                  class="tw-flex tw-items-center tw-justify-center tw-mb-8 tw-text-black-white-dynamic">
                  <mat-checkbox formControlName="termsAgreed" class="tw-text-sm">
                    I agree to the
                    <a
                      href="https://www.livedatatechnologies.com/legals"
                      target="_blank"
                      class="hover:tw-underline">
                      Terms and Privacy Policy
                    </a>
                  </mat-checkbox>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-stroked-button
                    (click)="cancelCreateAccount()"
                    class="tw-text-sm tw-leading-9">
                    Cancel
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [class.spinner]="loading"
                    [disabled]="createAccountGoogleForm.invalid || loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9">
                    Create Account
                  </button>
                </div>
              </form>
            </ng-container>

            <!-- They signed in with google, but don't have an account and have an invitation -->
            <ng-container *ngIf="cachedGoogleUser && inviteToken">
              <p class="tw-text-dark-light-dynamic tw-mb-6 tw-tracking-wide tw-text-base">
                You don't have an account yet. Would you like to create one with
                <span
                  class="tw-font-medium tw-text-gray-800 dark:tw-text-white tw-inline-block tw-px-2.5 tw-py-0.5 tw-rounded-md tw-bg-gray-200 tw-bg-opacity-80 dark:tw-bg-gray-700">
                  {{cachedGoogleUser?.email}}
                </span>
                ?
              </p>

              <form
                [formGroup]="acceptInviteGoogleForm"
                (ngSubmit)="acceptInviteWithGoogle()"
                class="tw-space-y-4 md:tw-space-y-6">
                <div
                  class="tw-flex tw-items-center tw-justify-center tw-mb-8 tw-text-black-white-dynamic">
                  <mat-checkbox formControlName="termsAgreed" class="tw-text-sm">
                    I agree to the
                    <a
                      href="https://www.livedatatechnologies.com/legals"
                      target="_blank"
                      class="hover:tw-underline">
                      Terms and Privacy Policy
                    </a>
                  </mat-checkbox>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-stroked-button
                    (click)="cancelCreateAccount()"
                    class="tw-text-sm tw-leading-9">
                    Cancel
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="acceptInviteGoogleForm.invalid || loading"
                    [class.spinner]="loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9">
                    Create Account
                  </button>
                </div>
              </form>
            </ng-container>

            <!-- They signed in with Microsoft, but don't have an account and have an invitation -->
            <ng-container *ngIf="cachedMicrosoftUser && inviteToken">
              <p class="tw-text-dark-light-dynamic tw-mb-6 tw-tracking-wide tw-text-base">
                You don't have an account yet. Would you like to create one with
                <span
                  class="tw-font-medium tw-text-gray-800 dark:tw-text-white tw-inline-block tw-px-2.5 tw-py-0.5 tw-rounded-md tw-bg-gray-200 tw-bg-opacity-80 dark:tw-bg-gray-700">
                  {{cachedMicrosoftUser?.email}}
                </span>
                ?
              </p>

              <form
                [formGroup]="acceptInviteGoogleForm"
                (ngSubmit)="acceptInviteWithMicrosoft()"
                class="tw-space-y-4 md:tw-space-y-6">
                <div
                  class="tw-flex tw-items-center tw-justify-center tw-mb-8 tw-text-black-white-dynamic">
                  <mat-checkbox formControlName="termsAgreed" class="tw-text-sm">
                    I agree to the
                    <a
                      href="https://www.livedatatechnologies.com/legals"
                      target="_blank"
                      class="hover:tw-underline">
                      Terms and Privacy Policy
                    </a>
                  </mat-checkbox>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-stroked-button
                    (click)="cancelCreateAccount()"
                    class="tw-text-sm tw-leading-9">
                    Cancel
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="acceptInviteGoogleForm.invalid || loading"
                    [class.spinner]="loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9">
                    Create Account
                  </button>
                </div>
              </form>
            </ng-container>

            <!-- Hit the page for the first time with no invite, show the standard signup form -->
            <ng-container *ngIf="!cachedGoogleUser && !cachedMicrosoftUser && !inviteToken">
              <form
                *ngIf="!inviteSent"
                [formGroup]="signupForm"
                (ngSubmit)="signupWithEmail()"
                class="tw-space-y-4 md:tw-space-y-6">
                <div>
                  <label
                    for="fullName"
                    class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                    Your Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    formControlName="fullName"
                    placeholder="First and last name"
                    required
                    class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                </div>
                <div>
                  <label
                    for="companyName"
                    class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    formControlName="companyName"
                    placeholder="Your new account name"
                    required
                    class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                </div>
                <div class="tw-relative">
                  <div>
                    <label
                      for="email"
                      class="tw-flex tw-items-center tw-gap-1 tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                      Email address
                    </label>
                    <input
                      type="email"
                      id="email"
                      formControlName="email"
                      placeholder="name@company.com"
                      required
                      class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                  </div>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="signupForm.invalid || loading"
                    [class.spinner]="loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9 tw-w-full">
                    Create Account
                  </button>
                </div>
              </form>
              <app-alert *ngIf="inviteSent" alertType="info" class="tw-mt-4">
                <span class="tw-text-sm">Please check your email for an invite.</span>
              </app-alert>
            </ng-container>

            <!-- They are here from an invite link in an email -->
            <ng-container *ngIf="!cachedGoogleUser && !cachedMicrosoftUser && inviteToken">
              <form
                [formGroup]="acceptInviteForm"
                (ngSubmit)="acceptInviteWithEmail()"
                class="tw-space-y-4 md:tw-space-y-6">
                <div>
                  <label
                    for="fullName"
                    class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                    Your Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    formControlName="fullName"
                    placeholder="First and last name"
                    required
                    class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                </div>

                <div class="tw-relative">
                  <div>
                    <label
                      for="password"
                      class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                      Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      formControlName="password"
                      placeholder="••••••••"
                      [type]="showPassword ? 'text' : 'password'"
                      required
                      (focus)="showPasswordRequirements = true"
                      (blur)="showPasswordRequirements = false"
                      class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                  </div>

                  <!-- pw requirements & validation  -->
                  <div
                    *ngIf="showPasswordRequirements"
                    class="ldt-tooltip ldt-tooltip-pwd tw-flex tw-flex-col tw-text-sm tw-text-blue-800 tw-rounded-lg tw-bg-blue-50 tw-p-4 tw-pr-10 tw-my-4
                    tw-absolute -tw-top-28 tw-z-10 tw-font-medium tw-shadow-sm tw-shadow-blue-600
                    tw-border tw-border-solid tw-border-blue-600
                    dark:tw-text-white dark:tw-bg-blue-700 dark:tw-border-blue-700"
                    role="tooltip">
                    <div class="tw-flex tw-items-center">
                      <mat-icon
                        class="material-icons-outlined tw-inline tw-text-[1.2rem] tw-h-5 tw-mr-1">
                        info_outline
                      </mat-icon>
                      <span class="tw-font-semibold">Password requirement:</span>
                    </div>

                    <ul class="tw-list-disc tw-list-inside tw-mt-1.5 tw-mb-0">
                      <li
                        *ngFor="let v of pValidation;"
                        class="tw-relative"
                        [ngClass]="{'tw-text-red-500 tw-font-semibold': !v.valid}">
                        <span class="tw-pr-1">{{v.text}}</span>
                        <mat-icon
                          *ngIf="!v.valid"
                          class="material-icons tw-absolute -tw-top-1 tw-text-red-500 tw-inline">
                          warning
                        </mat-icon>
                      </li>
                    </ul>
                  </div>

                  <div class="tw-flex tw-items-center tw-justify-between tw-mt-3">
                    <button
                      type="button"
                      (click)="togglePasswordVisibility()"
                      class="tw-text-gray-700 hover:tw-text-primary_purple-700 tw-transition-all tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary_purple-600 focus:tw-ring-offset-2 tw-rounded dark:tw-text-white dark:hover:tw-text-gray-100">
                      <span *ngIf="showPassword" class="tw-flex tw-items-center tw-gap-1">
                        <mat-icon class="tw-w-5 tw-h-5 tw-text-sm">visibility_off</mat-icon>
                        <span class="dark:hover:tw-underline dark:hover:tw-underline-offset-2">
                          Hide password
                        </span>
                      </span>
                      <span *ngIf="!showPassword" class="tw-flex tw-items-center tw-gap-1">
                        <mat-icon class="tw-w-5 tw-h-5 tw-text-sm">visibility</mat-icon>
                        <span class="dark:hover:tw-underline dark:hover:tw-underline-offset-2">
                          Show password
                        </span>
                      </span>
                    </button>
                  </div>
                </div>

                <div>
                  <label
                    for="confirmPassword"
                    class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    placeholder="••••••••"
                    [type]="showPassword ? 'text' : 'password'"
                    required
                    class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />

                  <app-alert
                    *ngIf="!checkPasswords(acceptInviteForm)"
                    alertType="error"
                    [alertStyle]="'compact'"
                    class="tw-mt-4">
                    <span class="tw-text-sm">Passwords do not match</span>
                  </app-alert>
                </div>

                <div
                  class="tw-flex tw-items-center tw-justify-center tw-mb-4 tw-text-black-white-dynamic">
                  <mat-checkbox formControlName="termsAgreed" class="tw-text-sm">
                    I agree to the
                    <a
                      href="https://www.livedatatechnologies.com/legals"
                      target="_blank"
                      class="hover:tw-underline hover:tw-underline-offset-2">
                      Terms and Privacy Policy
                    </a>
                  </mat-checkbox>
                </div>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-4">
                  <button
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="acceptInviteForm.invalid || loading"
                    [class.spinner]="loading"
                    class="tw-transition-all disabled:tw-opacity-80 disabled:tw-cursor-not-allowed tw-text-sm tw-leading-9 tw-w-full">
                    Create Account
                  </button>
                </div>
              </form>
            </ng-container>

            <app-alert *ngIf="error" alertType="error" [alertStyle]="'compact'">
              {{ error }}.
            </app-alert>

            <!-- Switch to login -->
            <div>
              <div class="tw-text-sm tw-font-light tw-text-gray-700 dark:tw-text-white tw-mb-2">
                Already a user?
                <a
                  href="javascript:void(0)"
                  (click)="navigateToLogin()"
                  class="tw-font-medium tw-text-dynamic-text-color hover:tw-underline hover:tw-underline-offset-2 tw-inline-block tw-ml-2">
                  Log in
                </a>
              </div>
            </div>
          </div>
        </div>

        <button
          *ngIf="isDialog && isPalMode"
          (click)="closeDialog()"
          class="tw-bg-blue-600 tw-bg-opacity-15 hover:tw-bg-opacity-25 tw-text-white tw-font-bold tw-py-3 tw-px-6 tw-rounded-full tw-flex tw-items-center tw-gap-2 tw-mt-6 tw-mb-6 tw-border tw-border-solid tw-border-blue-600 tw-transition-all">
          <mat-icon>arrow_back</mat-icon>
          Back to logged out view
        </button>
      </section>

      <!-- invite error -->
      <div *ngIf="inviteError">
        <app-alert id="login" alertType="error">
          {{inviteErrorMessage}}
        </app-alert>
        <p class="tw-text-sm tw-font-light tw-text-gray-700 dark:tw-text-white">
          Alternatively, you can create a free trial account, but you won't have access to the what
          was shared in the invite.
        </p>
        <a
          (click)="navigateToSignup()"
          class="tw-font-medium tw-text-link-color-dynamic hover:tw-underline hover:tw-underline-offset-2 tw-inline-block tw-mb-8">
          Create a free trial account.
        </a>
      </div>

      <!-- log in -->
      <section
        *ngIf="isActionLogin"
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-mx-auto lg:tw-py-0 lg:tw-min-w-[500px] tw-w-full dark:tw-bg-gray-900">
        <a routerLink="/" class="tw-mb-6 lg:tw-mb-8 tw-w-36 sm:tw-w-48">
          <img
            *ngIf="!isWorkforceLogin"
            class="ldt-logo"
            src="../../assets/img/logo-white.svg"
            alt="logo" />
          <img
            *ngIf="isWorkforceLogin"
            class="ldt-logo"
            src="../../assets/img/workforce_logo_white.svg"
            alt="logo" />
        </a>
        <div
          class="tw-w-full tw-bg-white tw-rounded-md tw-shadow md:tw-mt-0 sm:tw-max-w-md dark:tw-bg-gray-800 xl:tw-p-0">
          <div class="tw-p-6 tw-space-y-4 md:tw-space-y-6 sm:tw-p-8">
            <h1
              class="tw-text-xl tw-font-semibold tw-text-gray-800 dark:tw-text-gray-200 md:tw-text-2xl tw-my-0 tw-tracking-tight">
              Log in to your account
            </h1>

            <!-- Google Sign In Button - Moved to top -->
            <div class="tw-mt-4 tw-mb-6">
              <asl-google-signin-button
                type="standard"
                size="large"
                [theme]="'filled_white'"></asl-google-signin-button>
            </div>

            <!-- Microsoft Sign In Button -->
            <div class="tw-mb-6">
              <button
                type="button"
                (click)="signInWithMicrosoft()"
                class="tw-w-full tw-flex tw-items-center tw-px-3 tw-py-[9px] tw-text-sm tw-font-normal tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-primary_purple-500 tw-transition-all">
                <svg
                  class="tw-w-5 tw-h-5 tw-mr-3"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1h10v10H1z" fill="#f25022" />
                  <path d="M12 1h10v10H12z" fill="#00a4ef" />
                  <path d="M1 12h10v10H1z" fill="#ffb900" />
                  <path d="M12 12h10v10H12z" fill="#7fba00" />
                </svg>
                <span class="tw-flex-1 tw-text-center">Sign in with Microsoft</span>
              </button>
            </div>

            <!-- OR Divider -->
            <div class="tw-relative tw-py-2">
              <div class="tw-absolute tw-inset-0 tw-flex tw-items-center">
                <div class="tw-w-full tw-border-t tw-border-gray-300 dark:tw-border-gray-600"></div>
              </div>
              <div class="tw-relative tw-flex tw-justify-center">
                <span
                  class="tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
                  OR
                </span>
              </div>
            </div>

            <form class="tw-space-y-4 md:tw-space-y-6" [formGroup]="loginForm" (submit)="logIn()">
              <!-- pw-based sign-in -->
              <div>
                <label
                  for="email"
                  class="tw-block tw-mb-2 tw-text-sm tw-font-medium dark:tw-text-white">
                  Your email
                </label>
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  placeholder="name@company.com"
                  required
                  class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
              </div>
              <div>
                <div>
                  <label
                    for="password"
                    class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    formControlName="password"
                    placeholder="••••••••"
                    [type]="showPassword ? 'text' : 'password'"
                    required
                    class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-rounded focus:tw-ring-primary_purple-600 focus:tw-border-primary_purple-600 tw-block tw-w-full tw-p-2.5 dark:tw-bg-gray-600 dark:tw-border-gray-500 dark:tw-placeholder-gray-300 dark:tw-text-white" />
                </div>
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-12 tw-mt-3">
                  <button
                    type="button"
                    (click)="togglePasswordVisibility()"
                    class="tw-text-gray-700 hover:tw-text-primary_purple-700 tw-transition-all tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary_purple-600 focus:tw-ring-offset-2 tw-rounded dark:tw-text-white dark:hover:tw-text-gray-100">
                    <span *ngIf="showPassword" class="tw-flex tw-items-center tw-gap-1">
                      <mat-icon class="tw-w-5 tw-h-5 tw-text-sm">visibility_off</mat-icon>
                      <span class="dark:hover:tw-underline dark:hover:tw-underline-offset-2">
                        Hide password
                      </span>
                    </span>
                    <span *ngIf="!showPassword" class="tw-flex tw-items-center tw-gap-1">
                      <mat-icon class="tw-w-5 tw-h-5 tw-text-sm">visibility</mat-icon>
                      <span class="dark:hover:tw-underline dark:hover:tw-underline-offset-2">
                        Show password
                      </span>
                    </span>
                  </button>
                  <a
                    href="javascript:void(0)"
                    (click)="forgotPassword()"
                    class="tw-text-sm tw-font-medium tw-text-link-color-dynamic hover:tw-underline hover:tw-underline-offset-2 tw-transition-all">
                    Forgot password?
                  </a>
                </div>
              </div>

              <button
                mat-flat-button
                color="primary"
                type="submit"
                [disabled]="loginForm.invalid || loading"
                [class.spinner]="loading"
                class="tw-bg-link-color-dynamic tw-text-white-dark-dynamic tw-font-semibold tw-text-sm tw-leading-9 tw-w-full 
                hover:tw-bg-primary_purple-700 dark:hover:tw-bg-teal-400 tw-transition-all
                disabled:tw-opacity-75 disabled:tw-cursor-not-allowed">
                Log in
              </button>

              <!-- email/pw error -->
              <app-alert alertType="error" *ngIf="loginInvalid" class="tw-mb-4">
                You entered an invalid email or password
              </app-alert>

              <p class="tw-text-sm tw-font-light tw-text-gray-700 dark:tw-text-white">
                Don't have an account yet? Ask your administrator for an invite.
              </p>
              <a
                (click)="navigateToSignup()"
                class="tw-font-medium tw-text-link-color-dynamic hover:tw-underline hover:tw-underline-offset-2 tw-inline-block tw-mb-8">
                Or create a free trial account.
              </a>
            </form>
          </div>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <footer
      *ngIf="!isDialog"
      class="tw-flex tw-items-center tw-justify-center lg:tw-justify-start tw-flex-wrap tw-gap-6 lg:tw-gap-8 tw-bg-gray-800 dark:tw-bg-gray-900 tw-text-gray-400 dark:tw-text-white tw-py-4 tw-text-center tw-mt-auto tw-px-4 lg:tw-bg-gray-100 dark:lg:tw-bg-gray-900 lg:tw-text-gray-500 dark:lg:tw-text-white">
      <div class="lg:tw-ml-4 tw-text-sm">©2025 Live Data Technologies, Inc.</div>
      <nav class="tw-flex tw-justify-start tw-space-x-6">
        <a
          href="https://www.livedatatechnologies.com/privacy-policy"
          target="_blank"
          class="tw-flex tw-items-center tw-text-white tw-text-sm lg:tw-text-gray-700 dark:tw-text-white">
          <span class="hover:tw-underline hover:tw-font-semibold tw-transition-all">
            Privacy Policy
          </span>
          <mat-icon class="tw-text-base">north_east</mat-icon>
        </a>
        <a
          href="https://www.livedatatechnologies.com/terms-of-service"
          target="_blank"
          class="tw-flex tw-items-center tw-text-white tw-text-sm lg:tw-text-gray-700 dark:tw-text-white">
          <span class="hover:tw-underline hover:tw-font-semibold tw-transition-all">
            Terms of Use
          </span>
          <mat-icon class="tw-text-base">north_east</mat-icon>
        </a>
      </nav>
    </footer>
  </div>

  <app-side-img-decoration
    *ngIf="!isDialog"
    [isWorkforceLogin]="isWorkforceLogin"></app-side-img-decoration>
</div>
